import noop from 'lodash/noop';
import { createContext, useContext, useMemo } from 'react';

import { CurrencyE } from '../declarations/enums/currency';
import useReactRouter from '../hooks/useReactRouter';

const CURRENCY_OPTIONS = [
  { value: CurrencyE.USD, label: CurrencyE.USD },
  { value: CurrencyE.EUR, label: CurrencyE.EUR },
  { value: CurrencyE.GBP, label: CurrencyE.GBP },
];

type CurrencyCtxT = {
  rate: number;
  selectedCurrency: keyof typeof CurrencyE;
  currencyOptions: typeof CURRENCY_OPTIONS;
  onChangeCurrency: (value: CurrencyE) => void;
};

const defaultData = {
  rate: 1,
  selectedCurrency: CurrencyE.USD,
  currencyOptions: CURRENCY_OPTIONS,
  onChangeCurrency: () => noop,
};

const CurrencyCtx = createContext<CurrencyCtxT>(defaultData);

// This provider was created for checking currency rate,
// finish implementation when client approve
const CurrencyProvider: React.FC = ({ children }) => {
  const { getUrlQueryParams, setQuery } = useReactRouter();
  const { currency } = getUrlQueryParams<{ currency: CurrencyE }>();

  const onChangeCurrency = (value: CurrencyE) => {
    setQuery({ currency: value });
  };

  const value = useMemo(() => {
    return {
      rate: 1,
      selectedCurrency: currency || defaultData.selectedCurrency,
      currencyOptions: CURRENCY_OPTIONS,
      onChangeCurrency,
    };
  }, [currency]);

  return <CurrencyCtx.Provider value={value}>{children}</CurrencyCtx.Provider>;
};

export default CurrencyProvider;

export const useCurrency = () => useContext(CurrencyCtx);
